/* src/app/modules/shared/components/column/column-strain-type/column-strain-type.component.scss */
app-column-strain-type {
  display: contents;
}
/*# sourceMappingURL=column-strain-type.component.css.map */
